import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import GallerySection from "../components/Gallery/GallerySection";

function Gallery() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Liga Deportiva Cantonal Mejía</title>
        <meta
          name="description"
          content="Official gallery of the SAAC Basketball Quito 2026 tournament."
        />
      </Helmet>

      <GallerySection />
    </>
  );
}

export default Gallery;